import React, { useEffect } from 'react'
import './Latest_Articles.css'
import Common_Back_Header from '../../common/common_components/common_back_header/Common_Back_Header'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SingleInsightsArticle } from '../../../features/admin/common/Slice'
import { IDS } from '../../../utils/IDS'
import parse from "html-react-parser"
import { decodeId } from '../../../utils/common'

const Aticle_description = () => {

    const id = useParams();
    const dispatch = useDispatch();


    console.log(id, ";lll");


    const article = useSelector((state) => state.common.insight_article);
    useEffect(() => {
        if (id) {
            dispatch(SingleInsightsArticle({ id: decodeId(id.id) }));
        }
    }, [dispatch])


    return (
        <>
            <section className='Aticle_description_sec'>
                <div className='container'>
                    <Common_Back_Header backNavigation={-1} />
                    <div className='row'>
                        <div className='col-lg-5 mb-lg-0 mb-3'>
                            <div className='img_div'>
                                <img className='article_img' src={IDS.IMG_URL + article?.Insight_Article?.image} alt="article_img" />
                            </div>
                        </div>
                        <div className='col-lg-7 mb-lg-0 mb-3'>
                            <div className='content_div'>
                                <h5 className='arttitle'>{article?.name || " "}</h5>
                                <p className='artcont'>{parse(article?.description || " ")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='Aticle_description_sec'>
                <div className='container'>
                    <Common_Back_Header backNavigation={-1} />
                    <div className='row'>
                        <div className='col-lg-5 mb-lg-0 mb-3'>
                            <div className='img_div'>
                                <img className='article_img' src={process.env.PUBLIC_URL + '/assets/images/insight/latest_audio/img1.png'} alt="article_img" />
                            </div>
                        </div>
                        <div className='col-lg-7 mb-lg-0 mb-3'>
                            <div className='content_div'>
                                <h5 className='arttitle'>Article Title</h5>
                                <p className='artcont'>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    )
}

export default Aticle_description